import { ProfileFormInput } from 'Types/employee';
import { fetchProfile } from 'Services/profile.services';
import useDefaultRefreshOneFetchQuery from './default-refresh-one.hook';

function useRefreshOneProfileQuery(filters: any) {
  const results = useDefaultRefreshOneFetchQuery<ProfileFormInput>(
    {
      fetchService: fetchProfile,
    },
    [filters],
  );

  return results;
}

export default useRefreshOneProfileQuery;
